<template>
  <menu :class="className">
    <div class="navigation-side__content">
      <header class="navigation-side__header">
        <figure class="navigation-side__close" @click="$emit('close')">
          <svg-icon id="close" />
        </figure>
      </header>

      <nav class="navigation-side__list">
        <template v-for="(entry, i) in links">
          <a
            v-if="entry.external"
            :key="entry.label"
            :href="entry.link"
            target="_blank"
            rel="noopener noreferrer"
            :style="{ transitionDelay: `${200 + (i * 50)}ms` }"
            class="navigation-side__item navigation-side__cascade-item"
            @click="$emit('close')">
            {{ entry.label }}
          </a>

          <RouterLink
            v-else
            :key="entry.label"
            :to="{ hash: entry.hash }"
            :style="{ transitionDelay: `${200 + (i * 50)}ms` }"
            class="navigation-side__item navigation-side__cascade-item"
            @click.native="$emit('close')">
            {{ entry.label }}
          </RouterLink>
        </template>
      </nav>
    </div>
  </menu>
</template>

<script>
export default {
  name: 'NavigationSide',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  computed: {
    className() {
      return ['navigation-side', { '-open': this.isOpen }]
    },
    links() {
      const menu = this.$i18n.t('menu')
      return [
        { external: false, label: this.$i18n.t('menuLabels.home'), hash: '' },
        ...menu.map(entry => {
          return entry.external 
            ? { external: true, label: entry.label, link: entry.link }
            : { external: false, label: this.$i18n.t(`menuLabels.${entry.hash}`), hash: `#${entry.hash}` }
        })
      ]
    }
  }
}
</script>
